var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-pencil",
    clipPath: "url(#clip0_778_2233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.172 19.1174C0.421803 19.8674 0.00022655 20.8846 0 21.9454L0 23.9984H2.053C3.11378 23.9982 4.13103 23.5766 4.881 22.8264L18.224 9.48341L14.515 5.77441L1.172 19.1174Z",
    fill: "#A3A9B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.1447 0.853894C22.9012 0.610129 22.612 0.416749 22.2937 0.28481C21.9754 0.152872 21.6343 0.0849609 21.2897 0.0849609C20.9452 0.0849609 20.604 0.152872 20.2857 0.28481C19.9674 0.416749 19.6782 0.610129 19.4347 0.853894L15.9287 4.36089L19.6377 8.06989L23.1447 4.56389C23.3885 4.32038 23.5819 4.03121 23.7138 3.71292C23.8457 3.39463 23.9136 3.05345 23.9136 2.70889C23.9136 2.36434 23.8457 2.02316 23.7138 1.70487C23.5819 1.38657 23.3885 1.0974 23.1447 0.853894Z",
    fill: "#A3A9B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_2233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/iconPencil.dda7928bf0245c0ead2c2fa2bcfbe05f.svg";
export { ForwardRef as ReactComponent };